// src/appRedux/actions/Chat.js
import {
  SET_SESSION_ADDRESS,
  SET_ROOSTER_LIST,
  SET_COVERSATION_DATA,
  SET_SELECTED_CHAT_USER,
  SET_CHAT_USERS,
  RESET_CHAT_DATA
} from "../../constants/ActionTypes";
import {
  getChatListFromDjango,
  getChatUsersListRestApiEndpoint,
  postSendInternalMessageToDjango,
} from "../../api/endpoints";

export const setSessionAddress = (sessionAddress) =>
  function (dispatch) {
    dispatch({
      type: SET_SESSION_ADDRESS,
      payload: sessionAddress,
    });
  };

export const setChatUsers = (users) => function (dispatch) {
  dispatch({type: SET_CHAT_USERS, payload: users})
}

export const setSelectedUser = (suser) => function (dispatch) {
  dispatch({
    type: SET_SELECTED_CHAT_USER,
    payload: suser,
  });
}

export const setConversationData = (chatData) =>
  function (dispatch) {
    dispatch({ type: SET_COVERSATION_DATA, payload: chatData });
  };

export const setRosterList = (roosterList) =>
  function (dispatch) {
    dispatch({ type: SET_ROOSTER_LIST, payload: roosterList });
  };

export const appendMessaageToCoversationData = (message) =>
  function (dispatch, getState) {
    const state = getState();
    const conversationData = state?.chat?.conversationData;
    let newConversationData = [...conversationData];
    newConversationData.push(message);
    dispatch({ type: SET_COVERSATION_DATA, payload: newConversationData });
  };

export const searchChatUsers = (searchValue = "", sCall = () => {}, eCall = () => {}, fCall = () => {}) =>
  async function (dispatch) {
    try {
      const params = { search: searchValue };
      const response = await getChatUsersListRestApiEndpoint({
        params: params,
      });
      const users = response.data || [];
      if (response.status === 200 && users?.length > 0) {
        dispatch(setRosterList(users));
        sCall(users)
      } else {
        dispatch(setRosterList([]));
        eCall(response.data)
      }
    } catch (error) {
      console.log("[ChatActions] searchChatUsers Error", JSON.stringify(error));
      dispatch(setRosterList([]));
      eCall(error)
    } finally {
      fCall();
    }
  };

export const getChatUsersListDataDjango = (
  sCall = () => {},
  eCall = () => {}
) =>
  async function () {
    try {
      const uuid = localStorage.getItem("user_uuid");
      if (!uuid) {
        return;
      }
      const params = {
        userId: uuid,
      };
      const response = await getChatListFromDjango({ params });
      // console.log("getChatUsersListData RESPONSE", response.data);
      if (response.status === 200 && response.data?.data?.length > 0) {
        sCall(response.data);
        return response.data;
      } else {
        eCall(response.data);
        return null;
      }
    } catch (error) {
      eCall(error);
      console.log(
        "[ChatActions] getChatHistoryData Error",
        JSON.stringify(error)
      );
      return null;
    }
  };

export const sendMessageToChatDjango = ({
  recipientUUID,
  receiverName,
  messageText,
  sCall = () => {},
  eCall = () => {},
}) =>
  async function () {
    try {
      const uuid = localStorage.getItem("user_uuid");
      const fullname = localStorage.getItem("user_full_name");
      if (!uuid) {
        return;
      }
      const response = await postSendInternalMessageToDjango({
        receiver_id: recipientUUID,
        reciever_name: receiverName,
        sender_id: uuid,
        sender_name: fullname,
        message: messageText,
      });
      if (response.status === 201) {
        sCall(response.data);
      } else {
        eCall(response.data);
      }
    } catch (error) {
      console.log(
        "[ChatActions] sendMessageToChatNew Error",
        JSON.stringify(error)
      );
      eCall(error);
    }
  };

export const resetChatData = () => function (dispatch) {
  dispatch({ type: RESET_CHAT_DATA });
};
